module.exports = __webpack_public_path__ + "90f5bd8f06982e700fb8d5374970a8a1.png";